﻿export interface HubSpotFormOptions {
  [fieldName: string]: HubSpotFormOption;
}

export interface HubSpotFormOption {
  value: string;
  dependentFields?: HubSpotFormOptions;
}

export const isHubSpotFormOptions = (object: object): object is HubSpotFormOptions =>
  Object.entries(object).every(
    ([key, value]) => key.trim() !== "" && isHubSpotFormOption(value)
  );

export const isHubSpotFormOption = (object: unknown): object is HubSpotFormOption => {
  const option = object as HubSpotFormOption | undefined;

  return (
    option?.value !== undefined &&
    typeof option?.value === "string" &&
    (option?.dependentFields === undefined ||
      option?.dependentFields === null ||
      isHubSpotFormOptions(option?.dependentFields))
  );
};
